import api from './api';

const pauseTypesService = {
  async list() {
    return api.get('/api/pause-types');
  },
  async get(id) {
    return api.get(`/api/pause-types/${id}`);
  },
  async create(payload) {
    return api.post('/api/pause-types', payload);
  },
  async update(id, payload) {
    return api.request(`/api/pause-types/${id}`, { method: 'PATCH', body: payload });
  }
};

export default pauseTypesService;

